import {
  LayoutDashboard, Building2, Building, Users, ShieldCheck, KeyRound, CreditCard,
  Package, Boxes, Puzzle, ToggleRight, Gauge, Factory, Palette, FlaskConical,
  Handshake, Store, Settings, ScrollText, Activity, LineChart, Bell, FolderOpen,
  BrainCircuit, Contact, UserRound, Sparkles, PieChart, Circle,
  Target, UserPlus, Radio, TrendingUp, Columns3, PhoneCall, ListChecks,
  Inbox, Headset, MessageSquareText, Split,
  UserCheck, Timer, ShieldAlert, Languages, Mic, Globe,
  Gift, Wallet, Award, Coins, Ticket, BadgePercent, Crown,
} from "lucide-react";

export const ICONS = {
  LayoutDashboard, Building2, Building, Users, ShieldCheck, KeyRound, CreditCard,
  Package, Boxes, Puzzle, ToggleRight, Gauge, Factory, Palette, FlaskConical,
  Handshake, Store, Settings, ScrollText, Activity, LineChart, Bell, FolderOpen,
  BrainCircuit, Contact, UserRound, Sparkles, PieChart,
  Target, UserPlus, Radio, TrendingUp, Columns3, PhoneCall, ListChecks,
  Inbox, Headset, MessageSquareText, Split,
  UserCheck, Timer, ShieldAlert, Languages, Mic, Globe,
  Gift, Wallet, Award, Coins, Ticket, BadgePercent, Crown,
};

export const getIcon = (name) => ICONS[name] || Circle;
